import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { RestorableClassroom } from '@teetsh/app/src/types/classroom';

export const CLASSROOMS_TRASH_KEY = 'classrooms_trash';

function fetchClassroomsTrash() {
  const requestURL = '/classrooms/trash';
  return request(requestURL, {
    method: 'GET',
  }).then(({ data }: { data: RestorableClassroom[] }) => data || []);
}

export function useClassroomsTrash() {
  return useQuery({
    queryKey: [CLASSROOMS_TRASH_KEY],
    queryFn: () => fetchClassroomsTrash(),
    placeholderData: [],
    refetchOnWindowFocus: false,
  });
}
